import { RowSelectionProvider } from "@/components/data-table/context/RowSelectionProvider";
import { EmailRecipientsAddUsersDialogContent } from "@/modules/email-recipients/components/EmailRecipientsAddUsersDialogContent";
import { QueryKey } from "@tanstack/react-query";

interface EmailRecipientsAddUsersDialogProps {
  emailTypeId: string;
  queryKey: QueryKey;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const EmailRecipientsAddUsersDialog = ({
  emailTypeId,
  queryKey,
  isOpen,
  onOpenChange,
}: EmailRecipientsAddUsersDialogProps) => {
  if (!emailTypeId) {
    return null;
  }

  return (
    <RowSelectionProvider>
      <EmailRecipientsAddUsersDialogContent
        emailTypeId={emailTypeId}
        queryKey={queryKey}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      />
    </RowSelectionProvider>
  );
};
